<script>
import mixins from '../apimixins'
import api from '@utils/api'
import TablePaginator from '@components/paginator'

export default {
  name: 'MergedButNotInitializedPlugs',
  components: { TablePaginator },
  mixins: [mixins],
  data() {
    return {
      modelName: 'MergedButNotInitializedPlugs',
      headers: [
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'plugGuid', value: 'serial', sortable: true },
        { text: 'article', value: 'article', sortable: true },
        { text: 'merge_time', value: 'mergeTime', sortable: true },
      ],
      isLoading: false,
      sortBy: 'organisation',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getPaginator()
      let filters = this.getFilters()
      if (this.filtersEmpty(filters) || this.$route.params.fromNotification) {
        this.getDataSet()
      }
    },
    getDataSet() {
      this.isLoading = true
      this.prepareFilterParams()
      api
        .getReportData('merged_non_initialized', this.params)
        .then(response => {
          this.setResponseParams(response)
          this.content = response.content
          this.isLoading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            style="text-align: left"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less
            </v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '-' }}</span>
          </td>
          <td>
            <router-link
              v-if="userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.serial, goodsGroup: props.item.goodsGroup }} ">
              {{ props.item.serial }}
            </router-link>
            <span v-else>  {{ props.item.serial }} </span>
          </td>
          <td>
            <router-link
              v-if="userAllowedToNavigate"
              :to="{name:'goodsItem', params: {goodsId: props.item.goodsId.toString()}}">
              {{ props.item.articleName }}
            </router-link>
            <span v-else> {{ props.item.articleName }} </span>
          </td>
          <td>{{ dateFormat(props.item.mergeTime) }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)"/>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.sdTable {
  background: black;
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
